class UniqueItem{
    /**
	 * Create a new instance of a unique Nov Select item
	 * @param  {object} json A json object from novelist select with a ui property
	 */

    constructor(json) {
        this.uniqueId = json.ui;
    }
}

export default UniqueItem;


// WEBPACK FOOTER //
// ./src/models/UniqueItem.js